<template>
  <div
    class="pictureads"
    :style="{
      '--color': pointActiveColor,
      '--pointColor': pointUnActiveColor,
      '--arrowColor': arrowBgColor,
    }"
  >
    <div
      :style="{
        background: datas.backColor,
        'padding-top': datas.paddingTop + 'px',
        'padding-bottom': datas.paddingBottom + 'px',
        'padding-left': datas.paddingLeft + 'px',
        'padding-right': datas.paddingRight + 'px',
        'border-style': datas.borderStyle,
        'border-color': datas.borderColor,
        'border-width': datas.borderLineWeight + 'px',
        'border-radius': datas.borderRadius + 'px',
        'margin-top': datas.marginTop + 'px',
        'margin-bottom': datas.marginBottom + 'px',
        'margin-left': datas.marginLeft + 'px',
        'margin-right': datas.marginRight + 'px',
      }"
    >
      <!-- 无图片 -->
      <div v-if="!imageList[0]" class="upload">
        <img src="@/assets/images/defaultPic2.png" alt="" />
      </div>

      <div v-if="imageList[0]" class="swiper-container">
        <div
          :class="
            styleType === 4 || styleType === 5
              ? 'type3 swiper-wrapper'
              : 'swiper-wrapper '
          "
        >
          <div
            v-for="(item, index) in imageList"
            :key="index"
            class="swiper-slide"
            @click="handleClickImg(item)"
          >
            <!-- 图片 -->
            <img
              :src="item.imgUrl"
              alt=""
              draggable="false"
              :style="{
                'border-bottom-left-radius':
                  styleType === 2 ? '40% 20%' : '0 0',
                'border-bottom-right-radius':
                  styleType === 2 ? '40% 20%' : '0 0',
              }"
            />
            <div v-if="styleType === 3" class="circle" />
            <!-- 图片标题 -->
            <!-- <p v-show="item.text ? true : false" class="title">{{ item.text }}</p> -->
          </div>
        </div>

        <!-- 分页器 -->
        <div
          v-if="styleType === 1 || styleType === 2 || styleType === 3"
          class="swiper-pagination"
        />
        <div v-if="styleType === 6" class="swiper-button-prev">
          <i class="iconfont icon-houtui" />
        </div>
        <!--左箭头。如果放置在swiper外面，需要自定义样式。-->
        <div v-if="styleType === 6" class="swiper-button-next">
          <i class="iconfont icon-qianjin" />
        </div>
        <!--右箭头。如果放置在swiper外面，需要自定义样式。-->
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/css/swiper.min.css";
// import { Swiper, SwiperSlide } from "swiper/vue";
import { handleScanCode } from "@/utils";
export default {
  name: "Pictureads",
  // components: {
  //   Swiper,
  //   SwiperSlide
  // },
  props: {
    datas: Object,
  },
  data() {
    return {
      mySwiper: null,
    };
  },
  computed: {
    /* 类型切换 */
    styleType() {
      this.addSwiper();
      return this.datas.styleType;
    },
    /* 图片删除或者增加 */
    imageList() {
      this.addSwiper();
      return this.datas.imageList;
    },
    // /* 分页器类型切换 */
    // pagingType() {
    //   this.addSwiper();
    //   return this.datas.pagingType;
    // },
    carouselInterval() {
      console.log("cccccccccccc");
      this.addSwiper();
      return this.datas.carouselInterval;
    },
    pointActiveColor() {
      // this.addSwiper();
      return this.datas.pointActiveColor;
    },
    pointUnActiveColor() {
      // this.addSwiper();
      return this.datas.pointUnActiveColor;
    },
    arrowBgColor() {
      // this.addSwiper();
      return this.datas.arrowBgColor;
    },
    /* 一行个数 */
    // rowindividual() {
    //   this.addSwiper();
    //   if (this.datas.styleType === 1) {
    //     return 1;
    //   } else {
    //     return this.datas.rowindividual;
    //   }
    // },
    /* 图片间距 */
    imageMargin() {
      this.addSwiper();
      if (this.datas.styleType === 1) {
        return 0;
      } else {
        return this.datas.imageMargin;
      }
    },
  },
  watch: {
    carouselInterval() {
      console.log("变了！！！！！");
    },
    pointActiveColor() {},
    // pagingType() {},
    // rowindividual() {},
    imageMargin() {},
  },
  methods: {
    /* 创建轮播对象 */
    addSwiper() {
      this.$nextTick(() => {
        if (this.datas.imageList[0]) {
          if (this.mySwiper instanceof Array) {
            this.mySwiper.forEach((element) => {
              element.destroy();
            });
          } else if (this.mySwiper instanceof Object) {
            // 每次重新创建swiper前都要销毁之前存在的轮播   不然轮播会重复
            this.mySwiper.destroy();
          }

          const params = {
            // loop: true,
            // slidesPerView: "auto",
            slidesOffsetBefore: this.styleType == 4 ? -25 : 0,
            // spaceBetween: 17,
            // autoplay: true,
            autoplay: {
              delay: this.datas.carouselInterval,
            },
            pagination: {
              el: ".swiper-pagination",
              type: "bullets",
              bulletActiveClass: "my-bullet-active",
            },
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
          };

          if (this.datas.styleType === 4 || this.datas.styleType === 5) {
            params.slidesPerView = 1.3;
            params.centeredSlides = true;
          } else {
            params.slidesPerView = 1;
          }

          this.mySwiper = new Swiper(".swiper-container", params);
        } else {
          if (this.mySwiper instanceof Array) {
            this.mySwiper.forEach((element) => {
              element.destroy();
            });
          }
          // 每次重新创建swiper前都要销毁之前存在的轮播   不然轮播会重复
          if (this.mySwiper instanceof Object) {
            this.mySwiper.destroy();
          }
        }
      });
    },
    handleClickImg(item) {
      if (item.linkType == "scanCode") {
        // 调起微信扫码，扫码取号并自动跳转到扫码信息页面
        handleScanCode();
      } else if (item.linkUrl) {
        window.location.href = item.linkUrl;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.pictureads {
  position: relative;
  ::v-deep {
    // .my-bullet-class {
    //   width: 10px;
    //   height: 10px;
    // background-color: var(--pointColor);

    .swiper-pagination-bullet {
      width: 16px;
      height: 16px;
      background-color: var(--pointColor);
      opacity: 1;
      &.my-bullet-active {
        background-color: var(--color);
        opacity: 1;
      }
    }
    // }
    // --swiper-navigation-color: #00ff33; /* 单独设置按钮颜色 */
    .swiper-button-prev {
      left: 24px;
      .iconfont {
        font-size: 50px;
        color: var(--arrowColor);
      }

      &:after {
        display: none;
      }
    }

    .swiper-button-next {
      right: 24px;
      .iconfont {
        font-size: 50px;
        color: var(--arrowColor);
      }
      &:after {
        display: none;
      }
    }
  }
  .swiper-slide {
    position: relative;
    .circle {
      position: absolute;
      top: 86%;
      width: 100%; // 宽度大点，用来隐藏左右比较不平滑的弧度
      height: 100px; // 通过改变高度，可以调整弧度大小
      background: #fff;
      border-radius: 50% 50% 0 0; //
      // margin-left: -20%; // 隐藏左右比较不平滑的弧度，使整体平滑过渡
    }
  }

  /* 无图片 */
  .upload {
    background: #979797;
    width: 100%;
    height: 250px;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 100%;
      height: 100%;
    }
  }

  .swiper-wrapper {
    width: 100%;
    position: relative;
    .swiper-slide {
      width: 100%;
      height: 320px;
    }
    img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }

  .type3 {
    width: 100%;
    height: 360px;
    align-items: center;
    .swiper-slide {
      // width: 280px;
      height: 310px !important;
      text-align: center;
      font-size: 18px;
      background: #fff;
      box-shadow: rgba(173, 173, 173, 0.8) 0px 7px 24px 0px;
      border-radius: 12px;
      overflow: hidden;

      /* Center slide text vertically */
      // display: -webkit-box;
      // display: -ms-flexbox;
      // display: -webkit-flex;
      // display: flex;
      // -webkit-box-pack: center;
      // -ms-flex-pack: center;
      // -webkit-justify-content: center;
      // justify-content: center;
      // -webkit-box-align: center;
      // -ms-flex-align: center;
      // -webkit-align-items: center;
      // align-items: center;
      transition: 300ms;
      transform: scale(0.8);
      img {
        width: 100%;
        height: 100%;
      }
    }
    .swiper-slide-active,
    .swiper-slide-duplicate-active {
      transform: scale(1);
    }
    .swiper-pagination {
      bottom: 0 !important;
    }
  }
  // .type3H {
  //   height: 250px;
  // }
  .swiper-container-horizontal > .swiper-pagination-progressbar {
    height: 2px;
  }
}
</style>
